import React, { useRef } from 'react';

import useOnClickOutside from '../../hooks/useOnClickOutside';

type Props = {
	show: boolean;
	children: React.ReactNode;
	close: () => void;
};

function Modal({ show, children, close }: Props) {
	const ref = useRef(null);
	useOnClickOutside(ref, (): any => {
		close();
	});


	return (
		<>
			{
				show && (
				<div className="modal" >
					<div className="modal-body" ref={ref}>
						{children}
					</div>
				</div>
				)
			}
		</>
	);
}

Modal.defaultProps = {
	show: false
};

export default Modal;